// extracted by mini-css-extract-plugin
export var animatedSkeletonBlock = "_3k-1";
export var movingGradient = "_3k-4";
export var movingGradientBlock = "_3k-2";
export var skeleton = "_3k-0";
export var skeletonText = "_3k-3";